import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
    import THGTagInput from '@/components/thg/THGTagInput.vue';
    import { THGTag } from '@/interfaces/thg/THGTag';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGTagSelectModal',
  emits: ["select"],
  setup(__props, { emit }: { emit: ({
        (e: 'select', tags: THGTag[]): void;
    }), expose: any, slots: any, attrs: any }) {

    const selectedTags = ref<THGTag[]>([]);
    

    function onConfirm() {
        emit('select', selectedTags.value);
    }

return { __sfc: true,selectedTags, emit, onConfirm, THGTagInput }
}

})